export const GET_COMPANY_USERS_REQUEST = "GET_COMPANY_USERS_REQUEST";
export const GET_COMPANY_USERS_RESPONSE = "GET_COMPANY_USERS_RESPONSE";

export const CREATE_COMPANY_USER_REQUEST = "CREATE_COMPANY_USER_REQUEST";
export const CREATE_COMPANY_USER_SUCCESS = "CREATE_COMPANY_USER_SUCCESS";
export const CREATE_COMPANY_USER_FAILURE = "CREATE_COMPANY_USER_FAILURE";

export const GET_COMPANY_USER_REQUEST = "GET_COMPANY_USER_REQUEST";
export const GET_COMPANY_USER_RESPONSE = "GET_COMPANY_USER_RESPONSE";
export const CLEAR_COMPANY_USER = "CLEAR_COMPANY_USER";

export const UPDATE_COMPANY_USER_REQUEST = "UPDATE_COMPANY_USER_REQUEST";
export const UPDATE_COMPANY_USER_SUCCESS = "UPDATE_COMPANY_USER_SUCCESS";
export const UPDATE_COMPANY_USER_FAILURE = "UPDATE_COMPANY_USER_FAILURE";

export const DELETE_COMPANY_USER_REQUEST = "DELETE_COMPANY_USER_REQUEST";
export const DELETE_COMPANY_USER_SUCCESS = "DELETE_COMPANY_USER_SUCCESS";
export const DELETE_COMPANY_USER_FAILURE = "DELETE_COMPANY_USER_FAILURE";
